"use client"

import React, { createContext, useContext, useEffect, useState } from "react"

type Theme = "dark" | "light"

interface ThemeContextType {
    theme: Theme
    toggleTheme: () => void
}

const ThemeContext = createContext<ThemeContextType>({
    theme: "dark",
    toggleTheme: () => {},
})

export const useTheme = () => useContext(ThemeContext)

const STORAGE_KEY = "ea-theme"

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    const [theme, setTheme] = useState<Theme>("dark")
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        const stored = localStorage.getItem(STORAGE_KEY) as Theme | null
        const initial = stored === "light" ? "light" : "dark"
        setTheme(initial)
        document.documentElement.setAttribute("data-theme", initial)
        setMounted(true)
    }, [])

    const toggleTheme = () => {
        const next = theme === "dark" ? "light" : "dark"
        setTheme(next)
        localStorage.setItem(STORAGE_KEY, next)
        document.documentElement.setAttribute("data-theme", next)
    }

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            <div style={!mounted ? { visibility: "hidden" } : undefined}>
                {children}
            </div>
        </ThemeContext.Provider>
    )
}
